<!--答题-->
<template>
  <div class="content" :style="'background:'+$store.state.settingData.skin.data.color" @click='touchStart'>
    <!--顶部标题和倒计时-->
    <div class="top">
      <div class="title">{{ $store.state.formTitle }}</div>
      <div class="time" v-if="$store.state.settingData.exam.duration>0">
        {{ time.h }} : {{ time.m }} : {{ time.s }}
      </div>
    </div>
    <!--主体内容-->
    <div class="main">
      <div class="left">
        <div class="nav">
          <span :class='{active:navActive(item)}' v-for="(item,index) in questionDataAll"
                @click="changeItem(index)">{{ index + 1 | zero }}</span>
        </div>
        <div class="submit" @click="submitClick">提交试卷</div>
      </div>
      <div class="right">
        <div class="answer-scroll">
          <div class="top-bj"
               :style="{background: $store.state.settingData.skin.type ===1?'url('+$store.state.settingData.skin.data.head.image+')center':$store.state.settingData.skin.data.background.color,
                    height:$store.state.settingData.skin.type ===1?$store.state.settingData.skin.data.head.height+'px':$store.state.settingData.skin.data.background.paddingTop+'px',
                    backgroundSize: $store.state.settingData.skin.data.head.repeat==='x'?'contain':'cover'}">
          </div>
          <div class="answer-box">
            <myScroll size="3">
              <t-radio :question="questionCurrent" :number="currentIndex+1"
                       v-if="questionCurrent.subtype==='单选题'"></t-radio>
              <t-check :question="questionCurrent" :number="currentIndex+1"
                       v-if="questionCurrent.subtype==='多选题'"></t-check>
              <t-input :question="questionCurrent" :number="currentIndex+1"
                       v-if="questionCurrent.subtype==='填空题'"></t-input>
              <t-text-area :question="questionCurrent" :number="currentIndex+1"
                           v-if="questionCurrent.subtype==='简答题'"></t-text-area>
              <t-pan-duan :question="questionCurrent" :number="currentIndex+1"
                          v-if="questionCurrent.subtype==='判断题'"></t-pan-duan>
            </myScroll>
          </div>
        </div>
        <!--底部按钮-->
        <div class="bottom">
          <Button class="last" @click="lastQuestionClick" :disabled="currentIndex===0">上一题</Button>
          <Button class="next" @click="nextQuestionClick" :disabled="currentIndex===questionLength-1">下一题</Button>
        </div>
        <!--防作弊弹框提示-->
        <Modal class="model-box" v-model="isModal" :mask-closable="false" width="356"
               class-name="vertical-center-modal">
          <i-circle :percent="count/15*100" :size="98" stroke-color="#3760F4" trail-color="#E5E5E5" :stroke-width="12"
                    :trail-width="12" class="changeTimeOut">
            <span class="demo-i-circle-inner" style="font-size:24px"><span class="time">{{ count }}</span>秒</span>
          </i-circle>
          <div class="text" style="text-align:center">
            <p>请在倒计时内操作答题</p>
            <p>否则自动提交试卷</p>
          </div>
          <div slot="footer">
            <div class="btnClose" @click="close">关闭</div>
          </div>
        </Modal>
      </div>
    </div>

  </div>
</template>

<script>
import {cacheAnswers, formDetail, formSubmit} from "../../api/Interface";
import util from "../../utile/util";
import TRadio from "../../components/topicType/tRadio";
import TCheck from "../../components/topicType/tCheck";
import TPanDuan from "../../components/topicType/tPanDuan";
import TInput from "../../components/topicType/tInput";
import TTextArea from "../../components/topicType/tTextArea";

let TIME_COUNT = 15;
export default {
  name: "answer-pc",
  components: {TTextArea, TInput, TPanDuan, TCheck, TRadio},
  data() {
    return {
      count: null,
      changeOutSubmitInterval: '',
      timerInterval: '',
      touchTime: null,
      currentIndex: 0,
      questionLength: 1,
      questionCurrent: {},
      questionDataAll: [],
      answerData: {},
      countDown: '',
      time: {
        h: '',
        m: '',
        s: ''
      },
      //开始答题的时间戳
      stateTime: null,
      //结束答题时间戳
      endTime: null,
      //交卷时的时间戳
      submitTime: null,
      //答题限制时间(秒)
      contentTime: null,
      leftTime: null,
      openAnswerTime: null,
      isChangeTimeOut: false,
      isModal: false,
      flage: true,
      countdownTime: '',
      isRequireIdArr: [],
      //是否强制交卷
      forceSubmit: true
    }
  },
  created() {
    //开始答题的时间戳
    this.openAnswerTime = Date.parse(new Date());
  },
  mounted() {
    //答题限制时间(秒)
    this.contentTime = this.$store.state.settingData.exam.duration
    this.$store.state.surplusTime === null ? this.leftTime = this.contentTime : this.leftTime = this.$store.state.surplusTime
    this.getFormDetails()
    if (!this.$store.state.isSubmit) {
      //判断是否有设置答题时间
      if (this.$store.state.settingData.exam.duration > 0) {
        this.countTime()
      }
      if (this.$store.state.settingData.exam.timeout > 0) {
        this.changeTouch()
      }
    }
    //每隔一分钟缓存一次答案
    let _that = this
    const timer = setInterval(() => {
      _that.postCacheAnswers()
    }, 1000 * 60);
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer);
    })

    //监听页面刷新
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    //缓存当前倒计时
    beforeunloadFn(e) {
      if (e) {
        this.$store.commit('surplusTime', this.leftTime)
      }
    },
    //点击屏幕重置监听
    touchStart() {
      //触摸屏幕重置监听时间
      this.touchTime = this.$store.state.settingData.exam.timeout
      var _that = this;
      _that.flage = true
      TIME_COUNT = 15;
      clearInterval(_that.changeOutSubmitInterval);
    },
    //监听屏幕未操作
    changeTouch() {
      this.touchTime = this.$store.state.settingData.exam.timeout;
      this.flage = true;
      var _that = this;
      this.timerInterval = setInterval(() => {
        if (_that.touchTime > 0 && _that.touchTime <= _that.$store.state.settingData.exam.timeout) {
          _that.touchTime--;
          if (_that.touchTime <= 15) {
            _that.isModal = true
            if (_that.flage) {
              _that.changeOutSubmit()
              _that.flage = false
            }
          }
        } else {
          _that.forceSubmit = false
          clearInterval(_that.timerInterval);
          _that.submitClick()
        }
      }, 1000)
    },
    //监听作弊自动提示倒计时
    changeOutSubmit() {
      this.count = TIME_COUNT;
      var _that = this;
      this.changeOutSubmitInterval = setInterval(() => {
        if (_that.count > 0 && _that.count <= TIME_COUNT) {
          _that.count--;
          _that.isChangeTimeOut = true
        } else {
          clearInterval(_that.changeOutSubmitInterval);
          _that.isChangeTimeOut = false
        }
      }, 1000)
    },
    //关闭防作弊弹框
    close() {
      this.isModal = false;
      this.touchStart();
    },
    //上一题
    lastQuestionClick() {
      const cueeentAnswer = this.questionDataAll[this.currentIndex]
      if (cueeentAnswer.verify_rule.is_require) {
        if (this.$store.state.user_answers[cueeentAnswer.id] === '') {
          this.$Message.warning('此题必答')
          return
        }
      }
      this.currentIndex = this.currentIndex - 1
    },
    //下一题
    nextQuestionClick() {
      const cueeentAnswer = this.questionDataAll[this.currentIndex]
      if (cueeentAnswer.verify_rule.is_require) {
        if (this.$store.state.user_answers[cueeentAnswer.id] === '') {
          this.$Message.warning('此题必答')
          return
        }
      }
      this.currentIndex = this.currentIndex + 1
    },
    //左侧答题卡切换题目
    changeItem(index) {
      const cueeentAnswer = this.questionDataAll[this.currentIndex]
      if (cueeentAnswer.verify_rule.is_require) {
        if (this.$store.state.user_answers[cueeentAnswer.id] === '') {
          this.$Message.warning('此题必答')
          return
        }
      }
      this.currentIndex = index
    },
    //提交试卷
    submitClick() {
      if (this.forceSubmit) {
        for (let value of this.isRequireIdArr) {
          if (this.$store.state.user_answers[value] === '') {
            this.$Message.warning('必答题不能为空')
            return
          }
        }
      }
      clearInterval(this.timerInterval);
      clearInterval(this.changeOutSubmitInterval);
      clearInterval(this.countdownTime);
      this.submitTime = Date.parse(new Date());
      let timeCosting = (this.submitTime - this.openAnswerTime) / 1000
      let data = {
        form_id: this.$route.query.id,
        user_answers: this.$store.state.user_answers,
        time_costing: timeCosting,
      }
      if (this.$store.state.userInfoData.hasOwnProperty('user_name')) {
        data.user_name = this.$store.state.userInfoData.user_name
      }
      if (this.$store.state.userInfoData.hasOwnProperty('mobile')) {
        data.mobile = this.$store.state.userInfoData.mobile
      }
      if (this.$store.state.userInfoData.hasOwnProperty('company_name')) {
        data.company_name = this.$store.state.userInfoData.company_name
      }
      formSubmit(data).then(res => {
        if (res.state) {
          this.$store.commit('userInfoId', res.data.id)
          this.$router.push('/result-pc?id=' + this.$route.query.id)
          this.$store.commit('isSubmit', true)
          //提交答题清空缓存
          // sessionStorage.removeItem('vuex')
          this.$store.commit('user_answers', {})
          this.$store.commit('surplusTime', null)
        } else {
          this.$Message.error(res.error)
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //获取题目详情
    getFormDetails() {
      let data = {
        form_id: this.$route.query.id,
      }
      if (this.$store.state.code !== '') {
        data.code = this.$store.state.code
      }
      formDetail(data).then(res => {
        this.answerData = res.data
        this.questionLength = res.data.question.length
        this.questionDataAll = res.data.question
        this.questionCurrent = this.questionDataAll[this.currentIndex]
        //获取必答题id
        const isRequireObjArr = this.questionDataAll.filter(res => {
          return res.verify_rule !== null && res.verify_rule.is_require === true
        })
        this.isRequireIdArr = isRequireObjArr.map(res => {
          return res.id
        })
        let options = {}
        const idArr = this.questionDataAll.map(res => {
          return res.id
        })
        for (let i = 0; i < idArr.length; i++) {
          options[idArr[i]] = ''
        }
        //如果答案vuex中的答案对象(user_answers)为空就初始化答案对象，有答案则不初始化，防止答案丢失
        if (JSON.stringify(this.$store.state.user_answers) === '{}') {
          this.$store.commit('initUserAnswers', options)
        }
      })
    },
    //缓存用户答案
    postCacheAnswers() {
      let data = {
        form_id: this.$route.query.id,
        current_answers: this.$store.state.user_answers
      }
      cacheAnswers(data).then(res => {
        // console.log(res);
      }).catch(error => {
        console.log(error);
      })
    },
    //答题倒计时
    countTime() {
      //开始答题当前时间戳
      this.stateTime = Date.parse(new Date());
      //答题时间数组
      const timeArr = this.$store.state.settingData.base.day_limit
      const stateTime1 = Date.parse(new Date());
      for (let i = 0; i < timeArr.length; i++) {
        const start_time = Date.parse(new Date(timeArr[i].start_time));
        const end_time = Date.parse(new Date(timeArr[i].end_time));
        if (stateTime1 > start_time && stateTime1 < end_time) {
          this.endTime = end_time
        }
      }
      if ((this.endTime - this.stateTime) > this.contentTime * 1000 || this.endTime == null) {
        this.countdownTime = setInterval(() => {
          if (this.leftTime > 0 && this.leftTime <= this.contentTime) {
            this.leftTime--;
            if (this.leftTime >= 0) {
              this.time.h = Math.floor(this.leftTime / 60 / 60);
              this.time.m = Math.floor(this.leftTime / 60 % 60);
              this.time.s = Math.floor(this.leftTime % 60);
              if (this.time.s < 10) {
                this.time.s = "0" + this.time.s;
              }
              if (this.time.m < 10) {
                this.time.m = "0" + this.time.m;
              }
              if (this.time.h < 10) {
                this.time.h = "0" + this.time.h;
              }
            }
          } else {
            this.forceSubmit = false
            clearInterval(this.countdownTime);
            this.submitClick()

          }
        }, 1000)
      } else {
        this.leftTime = this.endTime - this.stateTime
        if (this.leftTime >= 0) {
          this.time.h = Math.floor(this.leftTime / 1000 / 60 / 60);
          this.time.m = Math.floor(this.leftTime / 1000 / 60 % 60);
          this.time.s = Math.floor(this.leftTime / 1000 % 60);
          if (this.time.s < 10) {
            this.time.s = "0" + this.time.s;
          }
          if (this.time.m < 10) {
            this.time.m = "0" + this.time.m;
          }
          if (this.time.h < 10) {
            this.time.h = "0" + this.time.h;
          }
          //递归每秒调用countTime方法，显示动态时间效果
          setTimeout(this.countTime, 1000);
        } else {
          _that.forceSubmit = false
          this.time.h = "00"
          this.time.m = "00"
          this.time.s = "00"
          this.submitClick()
        }
      }
    },
    navActive(val) {
      if (this.$store.state.user_answers[val.id] !== '') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    currentIndex: {
      handler(newVal, odlVal) {
        this.questionCurrent = this.questionDataAll[newVal]
      }
      ,
      deep: true
    },
  },

  filters: {
    zero: function (val) {
      if (val < 10) {
        return '0' + val
      }else {
        return val
      }
    }
  }
}
</script>
<style lang="scss">
.optionImg {
  width: 160px;
  height: 90px;

  img {
    height: 100%;
  }
}

.question-item-title {
  font-size: 16px;
  color: #000;
  margin-bottom: 15px;
  line-height: 30px;

  .q-title {
    p {
      display: contents;
    }
  }
}
</style>
<style lang="scss" scoped>
.content {
  /*background-color: #f5f7fa;*/

  .top {
    display: flex;
    width: 100%;
    height: 75px;
    background: #ffffff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);
    font-size: 22px;
    font-weight: bold;
    padding-left: 48px;
    line-height: 75px;

    .time {
      flex: 1;
      text-align: center;
      font-size: 28px;
      color: #F54643;
    }
  }

  .main {
    width: 1032px;
    height: calc(100% - 135px);
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: space-between;
    margin: 30px auto 0 auto;

    .left {
      width: 282px;
      box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.04);
      background-color: #fff;
      padding: 32px;

      .nav {
        height: calc(100% - 40px);
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(30px, 1fr));
        grid-template-rows: repeat(auto-fill, 30px);
        row-gap: 20px;
        column-gap: 17px;

        span {
          display: inline-block;
          width: 30px;
          height: 30px;
          border: 1px solid #dddddd;
          color: #747474;
          border-radius: 50%;
          text-align: center;
          line-height: 30px;
          font-size: 15px;
          font-weight: 500;

          &:hover {
            cursor: pointer;
          }
        }

        .active {
          background-color: #1a4bff;
          color: #ffffff;
        }
      }

      .submit {
        width: 100%;
        height: 40px;
        background: #3760f4;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        line-height: 40px;
        text-align: center;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .right {
      width: 726px;
      position: relative;
      background-color: #fff;

      .answer-scroll {
        height: calc(100vh - 210px);
        overflow-y: auto;
        /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
        &::-webkit-scrollbar {
          width: 5px;
          height: 8px;
        }

        /*定义滚动条轨道 内阴影+圆角*/
        &::-webkit-scrollbar-track {
          background-color: #ffffff;
        }

        /*定义滑块 内阴影+圆角*/
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: rgba(144, 147, 153, 0.3);
        }
      }

      .top-bj {
        height: 145px;
        width: 100%;
        background: url("../../assets/images/answer_bj.png") no-repeat center;
        background-size: cover;
        position: relative;
      }

      .answer-box {
        padding: 20px 15px;
        height: calc(100% - 245px);
        margin-right: -17px;

        /deep/ .__view {
          padding-right: 15px;
        }
      }

      .bottom {
        width: 100%;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        bottom: 0;
        padding: 25px 40px;

        .last {
          width: 115px;
          height: 41px;
          font-size: 18px;
          color: #303133;
        }

        .next {
          width: 115px;
          height: 41px;
          font-size: 18px;
          color: #303133;
        }
      }

    }
  }
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.model-box {
  position: relative;

  .demo-i-circle-inner {
    color: #292934;
    font-size: 20px;
    font-weight: 500;

    .time {
      font-size: 33px;
      padding-right: 2px;
    }
  }

  .changeTimeOut {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 50%;
  }

  /deep/ .ivu-modal-close {
    display: none;
  }

  /deep/ .ivu-modal {
    margin-top: 150px;
    height: 200px;
  }

  /deep/ .ivu-modal-footer {
    border: none;
  }

  /deep/ .ivu-modal-content {
    padding-top: 80px;
  }

  .text {
    color: #4E4C56;
    font-size: 16px;
    font-weight: 400;
  }

  .btnClose {
    width: 116px;
    height: 36px;
    background: #3760f4;
    border-radius: 18px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 36px;
    margin: auto;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
